import React, { useEffect } from "react"
import { Navigate, useLocation } from "react-router-dom"
import { toast } from "react-toastify"

const toastId = "private-route-error"
const containerId = "main"
const toastOptions =  {
  toastId,
  containerId
}

// Used as a <Route element={...}> guard rather than wrapping <Route> itself:
// react-router v6+ only accepts <Route> as a child of <Routes>.
function ProtectedRoute({
  component: Component, currentUser, enableNotification = true, redirectedRoute = "/", title = "Performance Intelligence Academy", ...rest
}) {
  const location = useLocation()

  useEffect(() => {
    document.title = title
  }, [title])

  if (currentUser?.firstname) {
    return <Component {...rest} currentUser={currentUser} />
  }

  if (enableNotification) {
    toast.error(
      <div>
        <span><i className="fa fa-exclamation mr-2" /></span>
        You must be logged in to access this page.
      </div>,
      toastOptions
    )
  }

  if (redirectedRoute === "/login") {
    window.location.href = "/login"
    return null
  }

  return (
    <Navigate
      replace
      state={{ from: location }}
      to={redirectedRoute} />
  )
}

export default ProtectedRoute
